import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ASYNC_USER_LOGOUT, CLEAR_AREA } from 'store';
import { Link, useHistory } from 'react-router-dom';
import { Nav, NavDropdown } from 'react-bootstrap';
import { api } from 'services';
import style from './style.module.scss';
import { useTranslation } from 'react-i18next';

import AlertNotification from '../AlertNotification';

const Header = ({
  user,
  enlarged,
  setEnlarged,
  className,
  logout,
  changeArea
}) => {
  const [countAreas, setCountAreas] = useState(0);
  const [languages, setLanguages] = useState([]);
  const history = useHistory();

  const { t, i18n } = useTranslation();

  useEffect(() => {
    api.get('areas-count').then(({ data }) => setCountAreas(data));
  }, []);

  useEffect(() => {
    api.get('languages').then(({ data }) => setLanguages(data));
  }, []);

  return (
    <div className={`${style.header} ${className}`}>
      <ul className="list-unstyled float-right mb-0">
        <Nav className="mr-auto">
          <NavDropdown className="nav-text-white" title={user.firstname}>
            <NavDropdown.Item
              onClick={() => history.push('/account')}
            >
              Minha Conta
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Header>{t('title:languages')}</NavDropdown.Header>
            {languages.map((language, k) => (
              <NavDropdown.Item
                key={k}
                onClick={() => i18n.changeLanguage(language.code)}
              >
                {language.name}
              </NavDropdown.Item>
            ))}
            <NavDropdown.Divider />
            {countAreas > 1 ? (
              <>
                <NavDropdown.Item onClick={changeArea}>
                  {t('title:change area')}
                </NavDropdown.Item>
                <NavDropdown.Divider />
              </>
            ) : null}
            <NavDropdown.Item onClick={logout}>
              {t('title:logout')}
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </ul>
      <AlertNotification userId={user.id}/>
     
      <ul className="list-unstyled m-0">
        <li>
          <button className="bars ml-3" onClick={() => setEnlarged(!enlarged)}>
            <i className="fas fa-bars"></i>
          </button>
        </li>
      </ul>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.user
});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch({ type: ASYNC_USER_LOGOUT }),
  changeArea: () => dispatch({ type: CLEAR_AREA })
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
